





import { Component, Vue } from "vue-property-decorator";
export const canW = 1650;
export const canH = 2475;
@Component
export default class BaseCanvasComponent extends Vue {
  ctx: CanvasRenderingContext2D | null = null;
  mounted(): void {
    this.ctx = (this.$el as HTMLCanvasElement).getContext("2d");
  }
}
